import styled from 'styled-components/macro';
export const MainContainerStyled = styled.main `
  position: relative;
  ${({ backgroundLink }) => backgroundLink && `background: url('${backgroundLink}') center / cover no-repeat fixed;`};
`;
